import React, { useState } from 'react';
import {
    MDBContainer,
    MDBNavbar,
    MDBNavbarToggler,
    MDBIcon,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBNavbarLink,
    MDBCollapse,
    MDBBtn,
} from 'mdb-react-ui-kit';
import { Link, useNavigate } from 'react-router-dom';
import { AiOutlineMenu } from "react-icons/ai";
import { useAlert } from "react-alert";

export default function Header() {
    let alert = useAlert();
    const [showBasic, setShowBasic] = useState(false);
    const [keyword, setKeyword] = useState();
    const navigate = useNavigate()

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!keyword) {
            return
        }
        if (keyword.length < 4) {
            alert.show("Debes hacer una busqueda mayor a 3 letras", {
                timeout: 3000,
                type: "error",
            });
            return;
        }
        navigate(`../searchresult?keyword=${keyword}`);
    };

    return (
        <MDBNavbar expand='lg' className='p4' style={{ background: "#020a5b" }}>
            <MDBContainer fluid>
                <MDBNavbarToggler
                    aria-controls='navbarSupportedContent'
                    aria-expanded='false'
                    aria-label='Toggle navigation'
                    onClick={() => setShowBasic(!showBasic)}
                >
                    <AiOutlineMenu color='white' />
                </MDBNavbarToggler>

                <MDBCollapse navbar show={showBasic}>
                    <MDBNavbarNav className='justify-content-center mb-2 mb-lg-0'>
                        <MDBNavbarItem>
                            <Link to={`/`} style={{ color: "white", fontSize: 15 }} className='noLink nav-link'>
                                Inicio
                            </Link>
                        </MDBNavbarItem>
                        <MDBNavbarItem>
                            <Link to={`/aboutus`} style={{ color: "white", fontSize: 15 }} className='noLink nav-link'>
                                ¿Quiénes Somos?
                            </Link>
                        </MDBNavbarItem>
                        <MDBNavbarItem>
                            <Link to={`/news`} style={{ color: "white", fontSize: 15 }} className='noLink nav-link'>
                                Noticias
                            </Link>
                        </MDBNavbarItem>
                        <MDBNavbarItem>
                            <Link to={`/boards`} style={{ color: "white", fontSize: 15 }} className='noLink nav-link'>
                                Estrados Electrónicos
                            </Link>
                        </MDBNavbarItem>
                        <MDBNavbarItem>
                            <Link to={`/faq`} style={{ color: "white", fontSize: 15 }} className='noLink nav-link'>
                                Preguntas Frecuentes
                            </Link>
                        </MDBNavbarItem>
                        <MDBNavbarItem>
                            <Link to={`/sitios`} style={{ color: "white", fontSize: 15 }} className='noLink nav-link'>
                                Sitios de Interés
                            </Link>
                        </MDBNavbarItem>
                        <MDBNavbarItem>
                            <Link to={`/observador`} style={{ color: "white", fontSize: 15 }} className='noLink nav-link'>
                                Observador Ciudadano
                            </Link>
                        </MDBNavbarItem>
                        <MDBNavbarItem>
                            <a href='https://www.municipiochihuahua.gob.mx/Directorio/Dependencia/%C3%93rgano_Interno_de_Control' target='_blank' style={{ color: "white", fontSize: 15 }} className='noLink nav-link'>
                                Contacto
                            </a>
                        </MDBNavbarItem>
                        <MDBNavbarItem className='my-auto'>
                            <form className='d-flex input-group w-auto' onSubmit={handleSubmit}>
                                <input type='search' className='form-control'
                                    onChange={(e) => setKeyword(e.target.value)}
                                    placeholder='Texto a Buscar' aria-label='Search' />
                                <MDBBtn color='link' className='my-auto btnlight'>
                                    <img src="Lupa.png" alt="" className='lupa' />
                                </MDBBtn>
                            </form>
                        </MDBNavbarItem>
                    </MDBNavbarNav>
                </MDBCollapse>
            </MDBContainer>
        </MDBNavbar>
    );
}